import { ReactComponent as ComponentSvg } from '@/declare/icons/component.svg';
import { ReactComponent as StructureSvg } from '@/declare/icons/structure.svg';
import { ReactComponent as EnviromentSvg } from '@/declare/icons/enviroment.svg';
import { ReactComponent as DeviceSvg } from '@/declare/icons/device.svg';

export const MonitorObjectType = {
    COMPONENT: 2,
    STRUCTURE: 3,
    ENVIRONMENT: 4,
    DEVICE: 5,
}

export const MonitorObjectTypeList = [
    { value: 2, label: '构件', color: '#FFDF86', icon: ComponentSvg },
    { value: 3, label: '结构', color: '#3F9CF2', icon: StructureSvg },
    { value: 4, label: '环境', color: '#86F7FF', icon: EnviromentSvg },
    { value: 5, label: '设备', color: '#FFF', icon: DeviceSvg },
]
